import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo } from "react";
import AnimatedToast from "./components/AnimatedToast";
import useToastLogic from "./hooks/useToastLogic";
import { BaseToaster } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function Toaster(_ref) {
  var toasts = _ref.toasts,
    onClose = _ref.onClose;
  var _useToastLogic = useToastLogic(toasts, onClose),
    _useToastLogic2 = _slicedToArray(_useToastLogic, 2),
    internalToasts = _useToastLogic2[0],
    controls = _useToastLogic2[1];
  return /*#__PURE__*/_jsx(BaseToaster, {
    children: internalToasts === null || internalToasts === void 0 ? void 0 : internalToasts.map(function (toast) {
      return /*#__PURE__*/_jsx(AnimatedToast, {
        toast: toast,
        setHover: controls === null || controls === void 0 ? void 0 : controls.setHover,
        removeToast: controls === null || controls === void 0 ? void 0 : controls.removeToast
      }, toast.id);
    })
  });
}
Toaster.displayName = "Toaster";
export default /*#__PURE__*/memo(Toaster);